<script>
const config = {
	'ApiUrl' : '',
	'CustomerServiceUrl' :  '',
	'LineCustomerServiceUrl' :  '',
	'company' : 'tckadm',
	//'company' : 'zxbit',
	'MyIP': '',
	'vendors' : [
		{
			label : '主帳戶',
			value : 'WALLET',
			icon : require('assets/images/wallet_icon.png'),
		},
		// {
		// 	label : 'WM真人',
		// 	value : 'WM',
		// 	icon : require('assets/images/wm_icon.png'),
		// },
		// {
		// 	label : '歐博真人',
		// 	value : 'ALLBET_LIVE',
		// 	icon : require('assets/images/allbet_icon.png'),
		// },
		// {
		// 	label : 'SA真人',
		// 	value : 'SA_LIVE',
		// 	icon : require('assets/images/SA_Gaming_Logo_B.283x347.png'),
		// },
// 		{
// 			label : 'OG真人',
// 			value : 'OG',
// 			icon : require('assets/images/og_icon.png'),
// 		},
		// {
		// 	label : 'DG真人',
		// 	value : 'DG',
		// 	icon : require('assets/images/dg_icon.png'),
		// },

// 		{
// 			label : 'QT電子',
// 			value : 'QT',
// 			icon : require('assets/images/qt_icon.png'),
// 		},
// 		{
// 			label : 'AE電子',
// 			value : 'AE',
// 			icon : require('assets/images/ae_icon.jpg'),
// 		},
// /* 		{
// 			label : 'PS電子',
// 			value : 'PS',
// 			icon : require('assets/images/ps_icon.png'),
// 		},
// 		{
// 			label : 'TTG電子',
// 			value : 'TTG',
// 			icon : require('assets/images/ttg_icon.png'),
// 		},
// */
// 		{
// 			label : 'RTG電子',
// 			value : 'RTG',
// 			icon : require('assets/images/rtg_icon.png'),
// 		},
// 		{
// 			label : '7PK',
// 			value : '7PK',
// 			icon : require('assets/images/7pk_icon.png'),
// 		},
// 		{
// 			label : 'VG對戰',
// 			value : 'VG',
// 			icon : require('assets/images/vg_icon.png'),
// 		},

// 			/*
// 		{
// 			label : 'DDFG捕魚',
// 			value : 'DDFG',
// 			icon : require('assets/images/ddfg_icon.png'),
// 		},*/
// 		{
// 			label : 'SUPER體育',
// 			value : 'SUPER',
// 			icon : require('assets/images/super_icon.jpg'),
// 		},
// 		{
// 			label : '瑪雅彩票',
// 			value : 'LOTTERY',
// 			icon : require('assets/images/lottery_icon.png'),
// 		},
// 		{
// 			label : 'Bingo Star',
// 			value : 'BINGO',
// 			icon : require('assets/images/bingo_icon.png'),
// 		},
// 		{
// 			label : 'AV影城',
// 			value : 'AV',
// 			icon : require('assets/images/av_icon.png'),
// 		},
		{
			label : '系統演算',
			value : 'CROWN',
			icon : require('assets/images/av_icon.png'),
		},
		// {
		// 	label : '指數下單',
		// 	value : 'VIX',
		// 	icon : require('assets/images/entertainment.png'),
		// },
		// {
		// 	label : 'AV電子',
		// 	value : 'F8',
		// 	icon : require('assets/images/f8_icon.png'),
		// },
	],
	'vendorsName': {
		// 'WM' : 'WM真人',
		//'ALLBET_LIVE' : '歐博真人',
		//'SA_LIVE' : 'SA真人',
		// 'OG' : 'OG真人',
		//'DG' : 'DG真人',
		// 'QT' : 'QT電子',
		// 'AE' : 'AE電子',
		// /* 'PS' : 'PS電子', */
		// /*'TTG' : 'TTG電子',*/
		// 'RTG' : 'RTG電子',
		// '7PK' : '7PK',
		// 'VG' : 'VG對戰',

		// //'DDFG' : 'DDFG捕魚',
		// 'SUPER' : 'SUPER體育',
		'CROWN' : '系統演算',
		//'VIX' : '指數下單',
		//'LOTTERY' : '瑪雅彩票',
		// 'BINGO' : 'Bingo Star',
		//'F8' : 'AV電子',
	},
	class:['一般會員','黃金會員','白金會員','鑽石會員'],
	tryGame:false,
};
export default { config }
</script>



// WEBPACK FOOTER //
// src/GlobalApp.vue